/* tslint:disable */
/* eslint-disable */
/**
 * OSB Workspaces manager API
 * Opensource Brain Platform - Reference Workspaces manager API
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Workspace Collaborator of a workspace
 * @export
 * @interface WorkspaceCollaborator
 */
export interface WorkspaceCollaborator {
    /**
     * 
     * @type {number}
     * @memberof WorkspaceCollaborator
     */
    id?: number;
    /**
     * Workspace Collaborator keycloak user id
     * @type {string}
     * @memberof WorkspaceCollaborator
     */
    userId: string;
}

export function WorkspaceCollaboratorFromJSON(json: any): WorkspaceCollaborator {
    return WorkspaceCollaboratorFromJSONTyped(json, false);
}

export function WorkspaceCollaboratorFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceCollaborator {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'userId': json['user_id'],
    };
}

export function WorkspaceCollaboratorToJSON(value?: WorkspaceCollaborator | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user_id': value.userId,
    };
}


